import axios from '@/axios';
import _ from 'lodash';

let accessToken = localStorage.accessToken;
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

const cacheExpiry = 0 * 1000; // for development, no cache at all 

export default {

  namespaced: true,

  actions: {

    async refreshList ( {state, commit}, payload ) {
      let notExpired = (await state.cache_expiry) > (new Date);
      let notEmpty = !_.isEmpty(await state.forms);

      if (notExpired && notEmpty) return;

      try {
        let res = await axios.get('/form');
        commit('UPDATE_FORMS', res.data.data);
        //TODO: split by organization ?
      } catch (e) {
        throw e;
      }
    },

    async createForm( {commit}, payload ) {
      try {
        let res = await axios.post('/form', payload);
        commit('CREATE_FORM', res);
      } catch (e) {
        throw e;
      }
    },

    async updateForm( {commit}, payload ) {
      try {
        let res = await axios.patch('/form', payload);
        commit('UPDATE_FORM', res);
      } catch (e) {
        throw e;
      }
    },

    async removeForm( {commit}, form_id ) {
      try {
        let res = await axios.delete(`/form/${form_id}`);
        commit('REMOVE_FORM', form_id);
      } catch (e) {
        throw e;
      }
    },

    async removeForms( {commit}, form_ids ) {
      try {
        //let res = await axios.delete('/form', payload);
        console.log(`Deleting form #${form_ids.join(', ')}`);
        commit('REMOVE_FORMS', form_ids);
      } catch (e) {
        throw e;
      }
    },

    async getSingleForm( {commit, state}, form_id ) {
      try {
        let now = new Date();
        let res = await axios.get(`/form/${form_id}?timestamp=${now.getTime()}`);
        commit('SET_CURRENT_FORM', res.data.data);
      } catch (e) {
        throw(e);
      }

    },

    async getSinglePublishedBrandedForm( {commit, state}, data) {
      try {
        var url="";
        if(data.subdomain===undefined || data.subdomain==="undefined" || data.subdomain==="")
        {
           url="/form/publishedlink/"+data.branded+"";
        }
        else
        {
          url="/form/publishedlink/"+data.subdomain+"/"+data.branded+"";
        }

        let res = await axios.get(url);
        commit('SET_CURRENT_PUBLISHED_FORM', res.data.data);
      } catch (e) {
        throw(e);
      }
    },

    async getSinglePublishedForm( {commit, state}, form_id) {
      try {
        let now = new Date();
        let res = await axios.get(`/form/published/${form_id}/?time=${now.getTime()}`);
        commit('SET_CURRENT_PUBLISHED_FORM', res.data.data);
      } catch (e) {
        throw(e);
      }

    },

    async getSinglePublishedFormOrder( {commit, state}, order_id) {
      try {
        let now = new Date();
        let res = await axios.get(`/form/order/${order_id}/?time=${now.getTime()}`);
        commit('SET_CURRENT_PUBLISHED_FORM', res.data.data);
      } catch (e) {
        throw(e);
      }

    },

    async getEditForm( {commit, state}, form_id ) {
      try {
        let now = new Date();
        let res = await axios.get(`/form/${form_id}?time=${now.getTime()}`);
        commit('SET_CURRENT_FORM', res.data.data);
      } catch (e) {
        throw(e);
      }

    },
  },

  mutations: {

    UPDATE_FORMS (state, payload) {
      state.forms = payload;
      state.cache_expiry = new Date((new Date) + cacheExpiry);
    },

    UPDATE_FORM (state, payload) {

      state.cache_expiry = new Date((new Date) + cacheExpiry);
    },

    CREATE_FORM (state, payload) {

      state.cache_expiry = new Date((new Date) + cacheExpiry);
    },

    REMOVE_FORM (state, form_id) {
      state.forms = state.forms.filter(x => x.id !== form_id);
      state.cache_expiry = new Date((new Date) + cacheExpiry);
    },

    REMOVE_FORMS (state, form_ids) {
      state.forms = state.forms.filter(x => form_ids.indexOf(x.id) < 0);
      state.cache_expiry = new Date((new Date) + cacheExpiry);
    },

    SET_CURRENT_FORM(state, payload) {
      state.current_form = payload;
    },
    SET_CURRENT_PUBLISHED_FORM(state, payload) {
      state.current_published_form = payload;
    },

  },

  state: {
    forms: [],
    cache_expiry: new Date(),
    current_form: {},
    current_published_form: [],
  }
}
